import { HStack } from '@/components/ui/hstack';
import { LoaderButton } from '@/components/ui/loader-button';

interface CitationRequestReviewFooterProps {
  publishCta: {
    label: string;
    isDisabled: boolean;
    onPress: () => void;
  };
  isPublishing: boolean;
  hasCandidates: boolean;
  /** Optional className override for the wrapping HStack. The native
   * actionsheet + the inline wizard use the default (`pb-8`); the web
   * modal overrides to `pb-4` because the modal chrome has its own
   * outer padding. */
  className?: string;
}

const DEFAULT_CLASSNAME = 'w-full flex-nowrap items-center gap-2 px-4 pb-8 pt-2';

/**
 * Publish CTA row for the citation-request review surface. Used by the
 * `InlineReviewPhase` of the triage wizard, which is the sole consumer
 * post-merge. Dismiss is owned by the host chrome (route header,
 * Actionsheet/Modal X), so this row carries only the primary action;
 * the `LoaderButton` wiring and `hasCandidates` gate stay here so
 * additional surfaces stay in sync.
 */
export function CitationRequestReviewFooter({
  publishCta,
  isPublishing,
  hasCandidates,
  className = DEFAULT_CLASSNAME,
}: CitationRequestReviewFooterProps) {
  return (
    <HStack className={className}>
      {/* Cancel intentionally removed — dismiss lives in the host
          chrome (the wizard route header's "Cancel" button, or the
          Actionsheet/Modal X icon). Keeping only the primary CTA here
          avoids redundant dismiss affordances and keeps focus on the
          publish action. */}
      <HStack className="ml-auto items-center gap-2">
        {hasCandidates ? (
          <LoaderButton
            onPress={publishCta.onPress}
            action="primary"
            variant="solid"
            size="sm"
            isLoading={isPublishing}
            isDisabled={publishCta.isDisabled}
            aria-label={publishCta.label}>
            {publishCta.label}
          </LoaderButton>
        ) : null}
      </HStack>
    </HStack>
  );
}
